<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-buy-modal" v-if="!comfirm">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-sale"></div>
                <div class="dialog-body">
                    <div class="buy-detail">
                        <div class="order-detail" :class="{'large' : !more_goods.giftId}">
                            <vuescroll>
                                <ul class="sale-list">
                                    <li class="clearfix"><em class="f-l">商品总价</em><p class="f-r">{{ settle.total }}<em class="icon-m3b"></em></p></li>
                                    <li class="clearfix"><em class="f-l">砍价已减</em><p class="f-r">{{ settle.total - settle.now }}<em class="icon-m3b"></em></p></li>
                                    <li v-for="(detail,shop) in settle.offer_detail" :key="shop" class="clearfix">
                                        <em class="f-l">{{ shop_dic[shop].discount }}</em>
                                        <p class="f-r">{{ detail.cut }}<em class="icon-m3b"></em></p>
                                    </li>
                                    <li v-if="settle.rate" class="clearfix"><p class="f-l">店铺优惠券<em class="shop-ticket"></em></p><p class="f-r">{{ settle.rate || 0 }}<em class="icon-m3b"></em></p></li>
                                </ul>
                                
                                <div class="basket-list">
                                    <ul v-if="list.length < 4">
                                        <li v-for="(item,index) in list" :key="index">
                                            <div class="goods-detail">
                                                <div class="goods-wrapper">
                                                    <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                                </div>  
                                            </div>  
                                        </li>
                                    </ul>
                                    <ul v-else>
                                        <li v-for="(item,index) in list.slice(0,3)" :key="index">
                                            <div class="goods-detail">
                                                <div class="goods-wrapper">
                                                    <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                                </div>  
                                            </div>  
                                        </li>                                
                                    </ul>
                                    <div class="cntor"><span v-if="list.length > 3">等</span>共{{ list.length }}件</div>
                                </div>

                            </vuescroll>
                        </div>

                        <div class="more-goods" v-if="more_goods.giftId">
                            <div class="tag"></div>
                            <div class="item-detail">
                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="more_goods.giftId"><game-item :locked="true" :id="more_goods.giftId" :num="more_goods.sendNum"></game-item></div>
                                    </div>  
                                </div>                                
                                
                                <div class="price-info">
                                    <h6 class="item-name">{{ more_goods.giftName }}</h6>
                                    <div class="price"><em class="icon-m3b"></em><span>{{ more_goods.price }}</span></div>                                          
                                </div>
                            </div>
                            <div class="check-box" :class="{'act' : buy_more}" @click="buy_more = !buy_more"></div>
                        </div>
                        <div class="total clearfix">
                            <em class="f-l">合计</em>
                            <p class="f-r">           
                                {{ buy_more ? (settle.now - settle.cut - settle.offer + more_goods.price) :  (settle.now - settle.cut - settle.offer) }}<em class="icon-m3b"></em>
                            </p>
                        </div>
                        <div class="u-btn apply" @click="comfirm = true;"></div>
                    </div>
                </div>          
            </div>         
        </div>

        <div class="u-window m-comfirm" v-else>
            <div class="dialog-content">
                <div class="u-btn close" @click="comfirm = false;"></div>
                <div class="dialog-wrapper">
                    <h5 class="title">确定花费{{ buy_more ? (settle.now - settle.cut - settle.offer + more_goods.price) :  (settle.now - settle.cut - settle.offer) }}梦三币购买所选道具？</h5>
                    
                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="comfirm = false;"></div>
                        <div class="u-btn ok" @click="orderSubmit"></div>                       
                    </div>
                    
                </div>
            </div>             
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            dialogVisible : false,
            shop_dic : shop_group.shop_dic,
            settle : () => {},
            list : [],
            total_cnt : 0,
            m3b : 0,
            more_goods : {},
            buy_more : false,
            comfirm : false,
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.total_cnt = this.list.length;
    },
    mounted(){
        //this.get_more_goods();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        },
        render_basket (){
            this.$get(ajax_url_map.basket_list,{
                success : (data) => {
                    this.$store.commit("$_setBasket", data.data.data);
                }
            })
        },        
        rate_sum (){
            var ret = 0;
            for(let shop in this.settle.offer_detail){
                console.log(this.settle.offer_detail[shop])
                ret += this.settle.offer_detail[shop].rate;
            }

            return ret;
        },         
        get_more_goods(){
            this.$get(ajax_url_map.ex_more_list,{
                success : (data) => {
                    this.more_goods = data.data
                }
            })
        },
        orderSubmit (){
            //if(this.m3b < this.settle.bill)return this.$toast('梦三币不足~');
            //this.$emit('m3bUpdate_offline',this.m3b - this.settle.bill);

            let temp_stage = [];
            let tid = '';

            for(let i = 0;i < this.list.length;i++){
                temp_stage.push(this.list[i].id);
            }

            //return this.render_basket ();

            if (this.settle.total >= 3000 && this.$store.state.tjlSwitch == 'on') {
                //TODO TJL
            }
            else{
                //todo ticket
                tid = this.settle.rate ? this.$store.state.ticket[0].ticketId : '';
                this.$post(ajax_url_map.buy,{
                    success : (data) => {
                        this.$toast('支付成功~');
                        this.destroyElement();

                        //ticket reflash
                        this.render_basket ();
                        if(tid)this.$task_render();
                    },
                    error : (data) => {
                        this.$toast(data.message);                       
                    }
                },{
                    payAmt : this.buy_more ? (this.settle.now - this.settle.cut - this.settle.offer + this.more_goods.price) :  (this.settle.now - this.settle.cut - this.settle.offer),
                    ticketId : tid,
                    gids : temp_stage,
                    tid : this.buy_more ? this.more_goods.id : 0,
                })
            }           

            
        },     
    },       
}
</script>

<style lang="scss" scoped>
.m-buy-modal {
    min-width: 625px;
    height: 700px;
    background-image: url(~@/assets/images/modal/bg-modal-submit.png);
}

.t-buy {
    width: 516px;
    height: 52px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/modal/title-buy.png);
}

.order-detail{
    height: 360px;
    padding-right: 20px;

    &.large{
        height: 500px;
    }
}

.buy-detail ul.sale-list {
    margin: 0 45px;
    padding: 12px 16px 0;
    background-color: #f8f7f3;
    border: 1px solid #ebe9e2;
}

ul.sale-list li {
    display: flex;
    justify-content: space-between;
    padding: 0 16px 12px;
    margin-bottom: 12px;
    border-bottom: 1px dashed #ebe9e2;
}

.total{
    position: absolute;
    left: 0;
    bottom: 120px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 72px;

    em{
        font-weight: 700;
        color: #696560;
    }

    p{
        font-weight: 700;
        color: #d33d27;        
    }
}

.m-buy-modal .basket-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    padding: 0 44px;
}

.basket-list ul{
    display: flex;

    li{
        margin-right: 10px;
    }
}

.basket-list .cntor {
    padding-right: 5px;
}

.m-buy-modal .u-btn.apply {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 186px;
    height: 56px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/modal/btn-buy.png);
}


.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 118px;
        height: 118px;
        margin: 0 auto;
        background-image: url(~@/assets/images/shop/bg-item.png);
    }

    .goods-pic{
        width: 69px;
        height: 69px;
    }
}

.more-goods{
    position: relative;
    margin: 10px 44px;
    padding: 10px 0;
    border-top: 1px solid #ebe9e2;
    border-bottom: 1px solid #ebe9e2;

    .tag{
        position: absolute;
        right: 40px;
        top: 20px;
        width: 109px;
        height: 31px;
        background-image: url(~@/assets/images/modal/tag-more.png);        
    }

    .check-box{
        position: absolute;
        right: 40px;
        top: 66px;
    }
}

.item-detail{
    display: flex;
    align-items: center;
    .price-info{
        margin-left: 20px;

        .item-name{
            margin-bottom: 10px;
            font-weight: 700;
            color: #7f572d;
            font-size: 24px;
        }

        .price span {
            font-size: 28px;
            font-weight: 700;
            color: #d33d27;
        }
    }
}

.check-box{
    width: 27px;
    height: 27px;
    background: url(~@/assets/images/basket/box-radio.png);

    &.act{
        background: url(~@/assets/images/basket/radio-check.png);
    }
}

.m-comfirm{
    position: relative;
    width: 625px;
    height: 365px;
    padding-top: 100px;
    box-sizing: border-box;      
    background-image: url(~@/assets/images/modal/bg-modal-comfirm.png);

    .title{
        font-weight: 400;
        font-size: 24px;
        color: #696560;
        text-align: center;   
    }

    .u-ctrl{
        position: absolute;
        width: 100%;
        left: 50%;
        bottom: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transform: translateX(-50%);
        box-sizing: border-box;
        padding: 0 110px;
    }

    .u-ctrl .u-btn.ok{
        width: 186px;
        height: 56px;
        background-image: url(~@/assets/images/modal/btn-submit.png);    
    }

    .u-ctrl .u-btn.cancel{
        width: 186px;
        height: 56px;
        background-image: url(~@/assets/images/modal/btn-cancel.png);    
    }    

}

</style>